// extracted by mini-css-extract-plugin
module.exports = {"container":"xf","hide":"xh","content":"xi","close":"xj","closeIcon":"xk","svgStyles":"xl"};